import { TemplateVariant } from '../template-variant/template-variant';

export class Template {
  type: string;
  key: string;
  name: string;
  isCustomizable: boolean;
  variables: string[];
  activeTemplateVariant: TemplateVariant;
  templateVariants: TemplateVariant[];

  constructor(payload?: any) {
    if (payload) {
      this.type = payload.type;
      this.key = payload.key;
      this.name = payload.name;
      this.isCustomizable = payload.isCustomizable;
      this.variables = payload.variables;
      if (payload.activeTemplateVariant) {
        this.activeTemplateVariant = new TemplateVariant(payload.templateVariant);
      }
      if (payload.templateVariants) {
        this.templateVariants = TemplateVariant.createTemplateVariants(payload.templateVariants);
      }
    }
  }

  static createTemplates(result: Array<any>): Template[] {
    const templates = new Array<Template>();
    if (result) {
      result.map((template) => {
        templates.push(new Template(template));
      });
    }
    return templates;
  }
}
